var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex_gap_10" },
    [
      _c(
        "v-popover",
        {
          attrs: {
            placement: "right",
            trigger: "hover",
            delay: { show: 100, hide: 500 },
          },
        },
        [
          _c(
            "span",
            {
              class: {
                "badge-success": _vm.task.status === 2,
                "badge-warning": _vm.task.status !== 2,
                "pointer badge": true,
              },
              on: {
                click: function ($event) {
                  return _vm.mixinOpenDrawer({
                    type: "drugTasks003",
                    task: { ..._vm.task, task_data: { ..._vm.task.task_data } },
                  })
                },
              },
            },
            [_c("i", { staticClass: "icon-fa icon-fa-phone" })]
          ),
          _vm._v(" "),
          _c("template", { slot: "popover" }, [
            _c(
              "div",
              [
                _vm._l(_vm.getComments(), function (c, i) {
                  return i < 2
                    ? _c("div", { staticClass: "comment" }, [
                        _c("p", [_vm._v(_vm._s(c.text))]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "text-right text-muted fs-11" },
                          [_vm._v(_vm._s(_vm.printDate(c.created_at)))]
                        ),
                      ])
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.getComments().length - 1 > 2
                  ? _c("div", [
                      _c("p", { staticClass: "text-right" }, [
                        _vm._v("всего комментариев: "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.getComments().length - 1)),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("span", [
        _vm._v(_vm._s(_vm.printDate(_vm.task.updated_at, "DD.MM.YYYY"))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }